import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class WarehouseReferenceService extends BaseReferenceService {
  constructor() {
    super('WarehouseReference');
  }

  // Only warehouses flagged Warehouse Pick. Used by the scanner's Picking screen - a
  // warehouse that does not pick its own stock cannot be picked from.
  picking(): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/Picking`);
  }
}
